import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { useAuth } from "@clerk/react";
import { makeApi } from "@/api";

const Ctx = createContext({ profile: null, setProfile: () => {}, refresh: () => {} });
export const useProfile = () => useContext(Ctx);

export default function ProfileProvider({ children }) {
  const { isSignedIn, getToken } = useAuth();
  const [profile, setProfile] = useState(null);

  const refresh = useCallback(() => {
    if (!isSignedIn) return setProfile(null);
    makeApi(getToken).get("/me").then(r => setProfile(r.data)).catch(() => {});
  }, [isSignedIn, getToken]);

  useEffect(() => { refresh(); }, [refresh]);

  return <Ctx.Provider value={{ profile, setProfile, refresh }}>{children}</Ctx.Provider>;
}
